// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"68":"cc888740","244":"cc888740","384":"cc888740","480":"cc888740","561":"cc888740","602":"cc888740","735":"c5d19741","916":"af72ab90","960":"cc888740"}[chunkId] + ".chunk.css";
};